export default __webpack_public_path__ + "static/media/logo-Global-Net1.6690d384.png";